const appConfig = {
  // Default App Configurations
  apiPrefix: "/api",
  authenticatedEntryPath: "/home",
  unAuthenticatedEntryPath: "/sign-in",
  twoFactorAuthentication: "/two-factor-authentication",
  tourPath: "/onboarding",
  enableMock: false,
  locale: "pt-br",

  // Custom App Configurations and environment vars
  indicafixSurveySvcUrl: `${import.meta.env.VITE_ADDRESS_SURVEY_SVC ?? "http://localhost:5050"}/v1`,
  indicafixAnswerSvcUrl: `${import.meta.env.VITE_ADDRESS_ANSWER_SVC ?? "http://localhost:5051"}/v1`,
  indicafixFrontendHost: import.meta.env.VITE_ADDRESS_FRONTEND_HOST,
  projectEnvironment: import.meta.env.VITE_PROJECT_ENV,
};

export default appConfig;
